import { Box, Card, CardBody, Flex } from '@chakra-ui/react';
import { ArticleNodeGroup } from '@texas/api/endpoints/articlesApi';
import { fadeInLeftAnimation } from '@texas/resources/animations/animations';
import { VersionsListView } from './VersionsListView';
import { VersionsFilters } from '../shared/VersionsFilters';
import { ControlledOptions } from './ControlledOptions';

interface Props {
  variantId: number;
  articleNodeGroup: ArticleNodeGroup;
  initialBranchId?: number;
}

export function MatrixVersions({
  variantId,
  articleNodeGroup,
  initialBranchId,
}: Props) {
  return (
    <>
      <Card variant="dark">
        <CardBody bg="gray.800" _light={{ bg: 'white' }}>
          <Flex gap={4}>
            <VersionsFilters
              variantId={variantId}
              articleNodes={articleNodeGroup}
              hideBranchFilter={true}
              initialBranchId={initialBranchId}
            />
          </Flex>
        </CardBody>
      </Card>
      <Card variant="dark" mt={4}>
        <CardBody>
          <ControlledOptions variantId={variantId} />
          <Box animation={fadeInLeftAnimation()}>
            <VersionsListView
              variantId={variantId}
              articleNodes={articleNodeGroup}
            />
          </Box>
        </CardBody>
      </Card>
    </>
  );
}
